import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import React from 'react';

type SubSectionProps = {
  title?: string;
  children: React.ReactNode;
};

const SubSection: React.FC<SubSectionProps> = ({ title, children }) => (
  <section css={containerStyles}>
    <h3 css={subSectionTitleStyles}>{title}</h3>
    {children}
  </section>
);

export default SubSection;

const containerStyles = css({
  position: 'relative',
  display: 'flex',
  gap: token('space.200'),
  padding: 0,
  flexDirection: 'column',
  alignItems: 'flex-start',
  '@media (max-width: 767px)': {
    alignSelf: 'stretch',
  },
});

const subSectionTitleStyles = css({
  color: token('color.text'),
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily: token('font.family.brand.body'),
  fontSize: token('space.150'),
  fontStyle: 'normal',
  fontWeight: token('font.weight.semibold'),
  lineHeight: token('space.200') /* 133.333% */,
  textTransform: 'uppercase',
});
